"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenIdentityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M73.212 146.633c-13.93-10.978-27.291-26.263-27.702-44.431l-.01-.938V60.381l54.561-23.656 54.561 23.656v40.897c0 18.317-13.521 33.826-27.768 45.009-7.051 5.533-14.115 9.878-19.424 12.841a143.678 143.678 0 01-6.395 3.37c-.539.265-.995.485-1.36.658a95.762 95.762 0 01-1.291-.63 138.874 138.874 0 01-6.22-3.297c-5.168-2.901-12.053-7.16-18.952-12.596z",
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 84,
    r: 25.5,
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 134c-8-10.493-21-15.5-39-15.5s-31 5.007-39 15.5",
    stroke: props.color || "#133251",
    strokeWidth: 5
  }));
}

var _default = SvgScreenIdentityOn;
exports["default"] = _default;